<template>
  <div class="quantity-inf">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button size="medium" @click="dialogVisible = true">显示列名</el-button>
        <advanced-class-query @search="search" />
        <div class="inline-block">
          <span>上课安排</span>
          <el-select
            @change="value => change('first_class_start_time', value)"
            :value="timeSort"
            placeholder="顺序"
            class="p-l-5 p-r-5"
            style="width:90px"
          >
            <el-option label="正序" value="asc"> </el-option>
            <el-option label="倒序" value="desc"> </el-option>
          </el-select>
        </div>
        <div class="inline-block">
          <span>创建时间</span>
          <el-select
            class="p-l-5 p-r-5"
            style="width:90px"
            @change="value => change('create_time', value)"
            :value="createTimeSort"
            placeholder="请选择顺序"
          >
            <el-option label="正序" value="asc"> </el-option>
            <el-option label="倒序" value="desc"> </el-option>
          </el-select>
        </div>
        <div class="inline-block">
          <span>名额状态</span>
          <el-select
            class="p-l-5 p-r-5"
            style="width:100px"
            v-model="searchFormData.class_sign_up_status"
            clearable
            placeholder="请选择状态"
          >
            <el-option label="已报满" :value="1"> </el-option>
            <el-option label="未报满" :value="2"> </el-option>
            <el-option label="已报超" :value="3"> </el-option>
          </el-select>
        </div>
        <div class="inline-block">
          <span>退费类型</span>
          <el-select
            class="p-l-5 p-r-5"
            style="width:100px"
            clearable
            v-model="searchFormData.refund_type"
            placeholder="请选择状态"
          >
            <el-option label="课程类" :value="1"> </el-option>
            <el-option label="活动类" :value="2"> </el-option>
            <el-option label="不退费" :value="3"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="search-group">
        <el-input
          placeholder="班级名称"
          clearable
          v-model.trim="searchFormData.query"
          @keydown.native.enter="() => search()"
        />
        <el-button type="primary" size="medium" @click="() => search()">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableConfig="tableConfig"
      :tableHeader="tableHeader"
      :paginConfig="paginConfig"
      :isShowOnly="isRate"
      :searchFormData="searchFormData"
      class="ly-card diy-table"
      ref="lyTable"
    >
      <template v-slot:countStatus="row">
        <span :class="countClass(row)">{{ row.sign_up_count }}/{{ row.class_count }}/{{ row.class_size }}</span>
      </template>
      <template v-slot:name="row">
        <el-button @click="showClass(row)" type="text" size="mini">{{ row.name }}</el-button>
      </template>
      <template v-slot:org="row">
        {{ row.fee_level.org_full_name && row.fee_level.org_full_name.replace(/中国儿童中心\/+/, '') }}
      </template>
      <template v-slot:specialized="row">
        {{ row.fee_level.specialized_subject_full_name | lastName }}
      </template>
      <template v-slot:teacher="row">
        {{ row.teacher | teacherFilter }}
      </template>
      <template v-slot:fee="row">
        {{ row.fee_level.name }}
      </template>
      <template v-slot:class_time="row">
        {{ `${row.first_class_start_time.split(' ')[0]} 至 ${row.last_class_end_time.split(' ')[0]}` }}
      </template>
      <template v-slot:class_time_sp="row">
        <div v-html="classTimeSp(row)"></div>
      </template>
      <template v-slot:class_periodic="row">
        {{ row.class_periodic | classPeriodic }}
      </template>
      <template v-slot:class_size="row">
        {{ row.class_size }}
      </template>
      <template v-slot:single_class_price="row">
        {{ row.fee_level.single_class_price }}
      </template>
      <template v-slot:class_status="row">
        {{ row | classStatus }}
      </template>
      <template v-slot:remuneration="row">
        {{ row.remuneration | remuneration }}
      </template>
      <template v-slot:action="row">
        <el-button type='text'  size="mini" @click.native="classInf(row,'refund')">批量退费</el-button>
        <el-button type='text'  size="mini" @click.native="classInf(row,'detail')">退费详情</el-button>
      </template>
    </ly-table>
    <set-table-header
      @close="dialogVisible = false"
      @change="setShowField"
      :itemKey="`classinfhd${isRate}`"
      :dialogVisible="dialogVisible"
      :tableHeader="tableHeader"
      ref="setTableHd"
    ></set-table-header>
    <el-dialog title="课程表" :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule @close="endSc" :action="true" :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
    <el-dialog title="班级信息" :visible.sync="dialogVisibleDetail" width="1000px">
      <class-inf-detail-list @showSc="showSc" :defaultFormItemClass="defaultFormItemClassList"></class-inf-detail-list>
    </el-dialog>
  </div>
</template>

<script>
import {
  Dialog,
  Input,
  Select,
  Option
} from 'element-ui';
import LyTable from '@/components/LyTable';
import { classApi } from '@/api';
import { classRefundTable } from '@/utils/tableHeaderClass';
import SetTableHeader from '@/components/SetTableHeader';
import ClassInfDetailList from '@/components/ClassInfDetail/list';
import AdvancedClassQuery from '@/components/AdvancedClassQuery';
import ClassSchedule from '@/components/ClassSchedule';
import classMixin from '@/utils/classMixin';
import perMixin from '@/utils/perMixin';
import localCache from '@/utils/localCache';

const Decimal = require('decimal.js');

export default {
  name: 'QuantityInf',
  mixins: [classMixin, perMixin],
  props: {
    isRate: {
      type: Boolean,
      default: () => false
    },
    tableHeaderDef: {
      type: Array,
      default: () => []
    }
  },
  components: {
    LyTable,
    ElInput: Input,
    ElDialog: Dialog,
    SetTableHeader,
    ClassSchedule,
    ClassInfDetailList,
    AdvancedClassQuery,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      createTimeSort: 'desc',
      timeSort: '',
      loading: false,
      sign_up_time: [],
      searchFormData: {
        query: '',
        class_sign_up_status: '',
        refund_type: ''
      },
      tableConfig: {
        align: 'center',
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      },
      paginConfig: {
        def_page_size: 20
      },
      selection: [],
      tableHeader: [],
      getTableData: classApi.getClassInf,
      dialogVisible: false,
      dialogVisibleDetail: false, // 非编辑信息展示
      isCopy: false,
      defaultFormItemClass: {},
      defaultFormItemClassList: {},
      dialogVisibleSc: false,
      scTime: {} // 课程表信息
    };
  },
  mounted() {
    this.search();
    if (this.tableHeaderDef.length) this.getHdEnum(this.tableHeaderDef);
    else this.getHdEnum(classRefundTable);
  },
  filters: {
    remuneration(value) {
      if (typeof value !== 'number') return '一';
      return `${Decimal.mul(value, 100).toNumber()} %`;
    }
  },
  activated() {
    this.search();
  },
  computed: {
    term() {
      return this.$store.state.schoolYear.term;
    },
    year() {
      return this.$store.state.schoolYear.year;
    }
  },
  methods: {
    searchDrafts() {
      this.$refs.drafts.search();
    },
    openEvent() {
      this.$refs.lyForm.$refs.lyForm.clearValidate();
    },
    setShowField(data) {
      this.tableHeader = data;
    },
    async search(data) {
      this.searchFormData = { ...this.searchFormData, ...data };
      this.$refs.lyTable.setData();
    },
    showClass(row) {
      this.defaultFormItemClassList = { ...row };
      this.dialogVisibleDetail = true;
    },
    controlClass(row) {
      this.defaultFormItemClass = { ...row };
      localCache.setItem('CLASS_INFO', this.defaultFormItemClass);
      this.$router.push(
        `/${this.$route.params.user_id}/classes/create/${row.id || -1}?isCopy=${
          this.isCopy
        }&is_confirm_split_class=${!!row.is_confirm_split_class}`
      );
    },
    classInf(row, type) {
      if (type === 'refund') {
        const routeUrl = this.$router.resolve(
        // eslint-disable-next-line max-len
          `/${this.$route.params.user_id}/pay/quantityRefund/${row.id}?class_phase=${row.class_phase_label}&courses_count=${row.courses_count}&single_class_price=${row.fee_level.single_class_price}&name=${row.name}&fee_level=${row.fee_level.specialized_subject_full_name}`
        );
        window.open(routeUrl.href, '_blank');
      } else {
        const routeUrl = this.$router.resolve(
        // eslint-disable-next-line max-len
          `/${this.$route.params.user_id}/pay/quantityRefundDetail/${row.id}?class_phase=${row.class_phase_label}&courses_count=${row.courses_count}&single_class_price=${row.fee_level.single_class_price}&name=${row.name}&fee_level=${row.fee_level.specialized_subject_full_name}`
        );
        window.open(routeUrl.href, '_blank');
      }
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: row.id
      };
    },
    endSc() {
      this.dialogVisibleSc = false;
      this.search();
    },
    change(key, value) {
      if (key === 'first_class_start_time') {
        this.createTimeSort = '';
        this.timeSort = value;
      } else {
        this.timeSort = '';
        this.createTimeSort = value;
      }
      this.searchFormData = {
        ...this.searchFormData,
        sorted_title: key,
        sorted_type: value
      };
      this.search();
    }
  }
};
</script>

<style lang="less" scoped>
.search-content {
  display: flex;
  justify-content: space-between;
  .search-group .el-input {
    width: 150px;
    margin-right: 20px;
  }
}
.field-label .el-checkbox {
  min-width: 100px;
  margin-bottom: 15px;
}
</style>
<style lang="less">
.quantity-inf {
  .el-dialog__body {
    padding: 15px 20px;
  }
  .el-date-editor .el-range-separator {
    width: 20px;
  }
  .small-week {
    .el-radio {
      margin-right: 5px;
    }
  }
  .diy-table .el-button{
    margin-left:0px;
  }
}
.dropdown-buttons {
  color: @main-blue;
}
.el-dropdown-menu .danger {
  color: @danger;
  &:hover {
    color: #f78989;
  }
}
</style>
